"use client";

import { cn } from "@/lib/utils";

/**
 * ParentalAdvisoryLabel — the official RIAA "PARENTAL ADVISORY / EXPLICIT
 * CONTENT" label. Renders the canonical artwork (`public/parental-advisory.svg`,
 * ~1.6:1 landscape) so it matches the real regulatory sticker exactly. The SVG
 * ships its own solid black field, so it stays legible over any cover art.
 *
 * Used to flag explicit releases — overlaid on cover art or shown in the age
 * gate. Callers usually wrap it in a fixed-width box and pass `w-full h-auto`
 * so it scales to the box while keeping the label's aspect ratio.
 */
export function ParentalAdvisoryLabel({
  width = 96,
  className,
  title = "Parental Advisory — Explicit Content",
}: {
  width?: number;
  className?: string;
  title?: string;
}) {
  return (
    // Static local asset — plain <img> avoids next/image SVG config; it's tiny.
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/parental-advisory.svg"
      alt={title}
      title={title}
      width={width}
      height={Math.round(width * 0.625)}
      // Explicit aspect-ratio so mobile Safari always computes a height even if
      // it doesn't infer the SVG's intrinsic ratio (fixes "logo missing on
      // mobile"). 147.5 : 92.2 ≈ 1.6:1.
      style={{ aspectRatio: "147.5 / 92.2" }}
      className={cn("block h-auto max-w-full select-none", className)}
      draggable={false}
    />
  );
}
